import React from 'react';
import css from '../purchased/index.module.css';
import Table, {
  TableColumn,
} from '../../../../../components/common/table/table';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useWarehouseContext } from '../warehouse-context';
import DealProduct from '../../../../../interfaces/deal-product';

const CreateDealUsedTable = (mode) => {
  const { t } = useTranslation();
  const { setIsOpenUsedProducts, setFormValues, farm } = useWarehouseContext();
  const { getValues, setValue } = useFormContext();

  const hiddenColumns: keyof DealProduct | (keyof DealProduct)[] = [
    'edit_deal',
    'delete_deal',
  ];

  const vatCoulmns: keyof DealProduct | (keyof DealProduct)[] = [
    'vat',
    'sum_with_vat',
    'vat_rate.label',
  ];

  const handleEdit = (id: string | number) => {
    const products = getValues('lost_products');
    const editableProduct = products.find((product) => product.id === id);
    setFormValues(editableProduct);
    setIsOpenUsedProducts(true);
  };

  const handleRemove = (id: string | number) => {
    const currentProducts = getValues('lost_products');

    const updatedProducts = currentProducts.filter(
      (product) => product.id !== id
    );

    setFormValues(updatedProducts);
    setValue('lost_products', updatedProducts);
  };

  const columns: TableColumn<DealProduct>[] = [
    {
      accessor: 'product_category_id.label',
      header: t('pages.warehouse.deals.product_category'),
      sortable: false,
      className: css['strong'],
    },
    {
      accessor: 'product_type_id.label',
      header: t('pages.warehouse.deals.product_type'),
      sortable: false,
      className: css['strong'],
    },
    {
      accessor: 'product_id.label',
      header: t('pages.warehouse.deals.name'),
      sortable: false,
      className: css['strong'],
    },
    {
      accessor: 'amount',
      header: t('pages.warehouse.deals.amount'),
      sortable: false,
      className: css['strong'],
      valuable: (value, deal: DealProduct) => {
        return `${value} ${
          typeof deal.unit === 'object' ? deal.unit.label : deal.unit
        }`;
      },
    },
    {
      accessor: 'product_warehouses',
      header: t('pages.warehouse.deals.party_number'),
      sortable: false,
      className: css['strong'],
      valuable: (value) => {
        if (value) {
          return value
            .filter((e) => !!e.party_number?.value ?? false)
            .map((e) => e.party_number?.value ?? null)
            .join(', ');
        }
        return '';
      },
    },
    {
      accessor: 'product_warehouses',
      header: t('pages.warehouse.deals.warehouse'),
      sortable: false,
      className: css['strong'],
      valuable: (value) => {
        if (value) {
          return (
            value
              .map((e) => e.warehouse_id.label)
              // filter unique values
              .filter((value, index, array) => array.indexOf(value) === index)
              .join(', ')
          );
        }
        return '';
      },
    },
    {
      accessor: 'edit_deal',
      header: '',
      className: css['strong'],
      cell: (deal: DealProduct) => (
        <button
          type="button"
          onClick={() => {
            handleEdit(deal.id);
          }}
        >
          {t('edit')}
        </button>
      ),
    },
    {
      accessor: 'delete_deal',
      header: '',
      className: css['strong'],
      cell: (deal: DealProduct) => (
        <button
          type="button"
          onClick={() => {
            handleRemove(deal.id);
          }}
        >
          &#10006;
        </button>
      ),
    },
  ];

  return (
    <>
      <Table<DealProduct>
        data={getValues('lost_products')}
        keyAccessor={'id'}
        paginate={false}
        columns={(mode === 'view'
          ? columns.filter(
              (column: TableColumn<DealProduct>) =>
                !hiddenColumns.includes(column.accessor as keyof DealProduct)
            )
          : columns
        ).filter((column: TableColumn<DealProduct>) =>
          !farm?.vat
            ? !vatCoulmns.includes(column.accessor as keyof DealProduct)
            : true
        )}
      />
    </>
  );
};

export default CreateDealUsedTable;
